import { Component, Vue } from "vue-property-decorator";
import Template from "./WriteOffModal.template.vue";

@Component({
  mixins: [Template]
})
export default class WriteOffModal extends Vue {}
